import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import { Loading } from "./../../components/loading/loading";

export interface FavoriteControlComponentParams {
    //DropDown Collection
    ItemCollections: KnockoutObservableArray<any>;

    //Selected Item ID
    ItemId: KnockoutObservable<string>;

    //QuickStart Caption property name to fetch caption from Item
    CaptionProperty: string;

    PrimaryKeyName: string;

    //QuickStart Sorting value
    Sort: number;

    //QuickStart Color CSS
    ColorCSS: string;

    //QuickStart Icon CSS
    IconCSS: string;
}

export class FavoriteControlComponent {
    Params: FavoriteControlComponentParams;
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    IsLoading = ko.observable(false);

    constructor(params: FavoriteControlComponentParams) {
        this.Params = params;

        this.Params.ItemId.subscribe(() => {
            this.isQuickStartModuleActive();
        });
    }

    //initialzie method
    init() {
        Loading.register(this.IsLoading);
    }

    //Toggle Favorite Status
    changeFavoriteStatus = () => {
        let promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => {
            Bao.raiseEvent('QuickStartModules:refresh', null);
        });
    };

    //Add Item to Quick Start Module
    addQuickStartModule = () => {
        let selectedItems: any[] = this.Params.ItemCollections().
            filter(e => e[this.Params.PrimaryKeyName] === this.Params.ItemId());
        let caption:string = selectedItems[0][this.Params.CaptionProperty];
        this.IsLoading(true);

        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: caption,
            caption2: caption,
            caption3: caption,
            caption4: caption,
            caption5: caption,
            webUrl: this.GetTabURL(),
            color: this.Params.ColorCSS,
            icon: this.Params.IconCSS,
            sort: this.Params.Sort
        })).done(result => {
            if (result) {
                this.IsFavorite(true);
            }
        }).always(_ => {
            this.IsLoading(false);
        });
    };

    //Check if active Quick Start Module
    isQuickStartModuleActive = () => {
        this.IsFavorite(false);
        this.IsLoading(true);
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetTabURL()
        })).done(result => {
            this.IsFavorite(result);
        }).always(_ => {
            this.IsLoading(false);
        });
    };

    //Remove Quick Start Module
    removeQuickStartModuleWebUrl = () => {
        this.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetTabURL()
        })).done(result => {
            if (result) {
                this.IsFavorite(false);
            }
        }).always(_ => {
            this.IsLoading(false);
        });
    };

    //Get Current Tab URL
    GetTabURL = () => {
        return "#/" + baoRouter.getHash();
    }
}